import { Button } from './ui/button'
import { ArrowRight, Shield, Clock, Users } from 'lucide-react'

const Hero = () => {
  return (
    <section id="home" className="bg-gradient-to-br from-blue-50 to-blue-100 py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Profesyonel
                <span className="text-blue-600 block">Antrepo Gümrük</span>
                Hizmetleri
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Uluslararası ticaret ve antrepo gümrük işlemlerinizde güvenilir çözüm ortağınız. 
                Uzman kadromuz ile hızlı, güvenli ve ekonomik hizmet sunuyoruz.
              </p>
            </div>

            

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">15+</div>
                <div className="text-sm text-gray-600">Yıl Tecrübe</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">500+</div>
                <div className="text-sm text-gray-600">Mutlu Müşteri</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">24/7</div>
                <div className="text-sm text-gray-600">Destek</div>
              </div>
            </div>
          </div>

          {/* Right Content - Features */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 p-3 rounded-lg">
                  <Shield className="text-blue-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Güvenli İşlemler</h3>
                  <p className="text-gray-600">
                    Tüm gümrük işlemlerinizi yasal mevzuatlara uygun şekilde güvenle gerçekleştiriyoruz.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-green-100 p-3 rounded-lg">
                  <Clock className="text-green-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Hızlı Çözümler</h3>
                  <p className="text-gray-600">
                    Deneyimli ekibimiz ile gümrük işlemlerinizi en kısa sürede tamamlıyoruz.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-purple-100 p-3 rounded-lg">
                  <Users className="text-purple-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Uzman Kadro</h3>
                  <p className="text-gray-600">
                    Alanında uzman gümrük müşavirleri ile profesyonel danışmanlık hizmeti.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
